import { LinkState } from '@/models/interfaces'
import { ContentType } from '@/services/directr'
import { Entry } from '@Protium/vue-ozone-utils'
import { reactive, Ref, WritableComputedRef } from 'vue'
import { Store } from 'vuex'

export default function Linker<C extends Entry> (payload: Ref<Entry | null | undefined> | WritableComputedRef<Entry | null | undefined>, $store:Store<any>) {
  const $directr = $store.getters['Services/Directr']

  const state = reactive<LinkState<C>>({
    field: '',
    items: [],
    selection: [],
    show: false,
    contentType: undefined,
    active: payload,
    selectionLimit: 1
  })

  function commit () {
    // NOTE cast to C because of vue UnwrapRefSimple typing issues causing ts to think type C is not the same type as passed to UnwrapRefSimple<C>
    const item:C = state.selection[0] as C
    if (!state.active || !item) return
    // console.log('commitLink', state.active, state.active[state.field], state.field, item)

    state.active[state.field] = item.sys.id
    // console.log('set', state.active[state.field], state.active)

    state.field = ''
    state.selection = []
    state.contentType = undefined
    state.show = false
  }

  // TODO: refactor to useLink... also, use entrySearch where appropriate... in tandem with useLink
  function select (item) {
    if (state.selection.length >= state.selectionLimit) return
    const i = state.selection.findIndex(i => i.sys.id === item.sys.id)
    if (i >= 0) state.selection.splice(i, 1)
    else state.selection.push(item as never)
  }

  function link (field:string, type:ContentType) {
      // console.log('setActiveLinkField', field, state.active && state.active[field])

      state.field = field
      state.contentType = type || field
      state.show = true

      // small exception for datamap, since we want to add a query to the request
      const query = type !== 'datamap' ? [] : [{ field: 'type', method: 'is', match: 'order' }]

      $directr.get(state.contentType, query)
        .then(({ sys, items }) => {
          state.items = items
        }).catch(console.error)
    }

  return {
    commit,
    select,
    link,
    state
  }

}
